import React, { useState, useEffect, useMemo } from 'react';
import { VbzButton, VbzModal, VbzInputPassword, VbzDivider } from '@smiles/voebiz-ui-kit';
import { ModalBody } from 'reactstrap';
import { useTranslation } from 'react-i18next';

import { redirectToHome } from '../../../utils/redirectToHome';
import { usePasswordValidation } from '../../../hooks/usePasswordValidation';
import logoHeaderMobileVoebiz from '../../../assets/voebiz-logo-header-mobile.svg';
import logoFooterGroupVoebiz from '../../../assets/footer-group-logos.svg';
import logoHeaderGroupVoebiz from '../../../assets/header-group-logos.svg';

interface INewPassword {
  onFinish: (password: string) => void;
}

const NewPassword: React.FC<INewPassword> = ({ onFinish }) => {
  const { t } = useTranslation('new_password');
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [password, setPassword] = useState('');
  const [isValidPassword, setIsValidPassword] = useState(true);
  const pathHome = useMemo(() => redirectToHome(true), []);
  const passwordValidation = usePasswordValidation(password, 8, 20);
  const [isMobile, setIsMobile] = useState(false);
  const [imageFooter, setImageFooter] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.slice(0, 20);
    setPassword(value);
  };

  window.addEventListener('resize', () => {
    if (window.innerWidth < 769) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  });

  useEffect(() => {
    if (window.innerWidth < 769) {
      setIsMobile(true);
    }
  }, [isMobile]);

  const checkIsValidPassword = () => {
    const [hasValidLength, hasNumber, hasUpperCase, hasLowerCase, hasSpecialChar, hasNotBarra, hasNotSignal] =
      passwordValidation;
    return hasValidLength && hasNumber && hasUpperCase && hasLowerCase && hasSpecialChar && hasNotBarra && hasNotSignal;
  };

  useEffect(() => {
    setIsValidPassword(password.length < 4 || checkIsValidPassword());
  }, [passwordValidation]);

  useEffect(() => {
    setImageFooter(logoFooterGroupVoebiz);
  }, []);

  const handleFinish = () => {
    onFinish(password);
  };

  const handleKeyPressPassword = (e: React.KeyboardEvent) => {
    if (e.key === '.' || e.key === ',' || e.key === '/' || e.key === ';' || e.key === `"`) {
      e.preventDefault();
    }
  };

  const rules: Array<string> = t('rules', { returnObjects: true });

  return (
    <>
      <div className="vbz-new-password">
        <div className="vbz-home-header">
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <a href={pathHome}>
              <span className="vbz-logos">
                <img src={isMobile ? logoHeaderMobileVoebiz : logoHeaderGroupVoebiz} />
              </span>
            </a>
          </div>
        </div>
        <div className="vbz-content">
          <h3>{t('title')}</h3>
          <p>{t('message')}</p>
          <div>
            <VbzInputPassword
              placeholder="o  o  o  o  o  o  o  o"
              idInput="inp_password"
              idPreviewOn="lbl_previewDisabled"
              idPreviewOff="lbl_previewEnabled"
              idErrorMsg="lbl_msgInvalid_1"
              error={!isValidPassword && password.length >= 4 && password.length <= 20}
              errorMessageList={[t('invalid')]}
              onChange={handleChange}
              onlyNumbers
              onKeyPress={handleKeyPressPassword}
            />

            {isMobile ? (
              <>
                <div className="vbz-row">
                  <VbzButton
                    id="btn_securityRule"
                    color="hyperlink"
                    text={t('security_rules')}
                    onClick={() => setModalIsOpen(true)}
                  />
                  <VbzButton
                    id="btn_continue"
                    disabled={!isValidPassword}
                    color="primary"
                    text={t('confirm_password')}
                    onClick={handleFinish}
                  />
                </div>
              </>
            ) : (
              <div className="vbz-row">
                <VbzButton
                  id="btn_continue"
                  disabled={!isValidPassword}
                  color="primary"
                  text={t('confirm_password')}
                  onClick={handleFinish}
                />
                <VbzButton
                  id="btn_securityRule"
                  color="hyperlink"
                  text={t('security_rules')}
                  onClick={() => setModalIsOpen(true)}
                />
              </div>
            )}
            {isMobile && (
              <>
                <div className="footer-group">
                  <p className="label-footer-group">Clientes VoeBiz voam com:</p>
                  <img src={imageFooter}></img>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <VbzModal isOpen={modalIsOpen} type="right" toggle={() => setModalIsOpen(false)} className="modal-password">
        <ModalBody>
          <h3>{t('rules_title')}</h3>
          <ul>
            {rules.map((rule) => (
              <li key={rule}>{rule}</li>
            ))}
          </ul>
          <VbzButton id="btn_gotIt" onClick={() => setModalIsOpen(false)} text={t('rules_understand')} />
        </ModalBody>
      </VbzModal>
    </>
  );
};

export default NewPassword;
